import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import {
  formatProposal,
  processProposalResponse,
  processPdfResponse,
} from './utils';

const PROPOSAL_URL = `${API_CONFIG.API}/node/proposal`;
const PROPOSAL_BY_OP = '/?filter[id_operation.uuid][value]=';
const PDF_BY_PROPOSAL = `${API_CONFIG.API}/file/document/`;
export default {
  createProposal(proposal) {
    return base.http().post(`${PROPOSAL_URL}`, formatProposal(proposal));
  },
  updateProposal(proposal) {
    return base.http().patch(`${PROPOSAL_URL}/${proposal.id}`, formatProposal(proposal));
  },
  getProposal(opid) {
    return base.http().get(`${PROPOSAL_URL}${PROPOSAL_BY_OP}${opid}`)
      .then(res => processProposalResponse(res));
  },
  getPdfLink(pdfId) {
    return base.http().get(`${PDF_BY_PROPOSAL}${pdfId}`)
      .then(res => processPdfResponse(res));
  },
};



// WEBPACK FOOTER //
// ./src/features/propuesta-no-vinculante/service.js